import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { KeenIcon } from '@/components';

const StatCard = ({ number, title, icon, iconType = 'fontawesome', className = '' }) => {
  const renderIcon = () => {
    if (!icon) return null;
    
    if (iconType === 'keenicon') {
      return <KeenIcon icon={icon} className="text-[#296D2B] text-xl" />;
    }
    
    // Default to FontAwesome
    return <FontAwesomeIcon icon={icon} className="w-5 h-5 text-[#296D2B]" />;
  };

  return (
    <div className={`bg-white shadow-lg border rounded-lg p-5 ${className}`}>
      <div className="flex items-center justify-between">
        <div className="flex flex-col">
          <span className="text-lg font-bold text-[#1A4463] mb-1">
            {number}
          </span>
          <span className="text-base text-[#7C7C7C]">
            {title}
          </span>
        </div>
        <div className="w-11 h-11 bg-[#ECFBEC] rounded-full flex items-center justify-center">
          {renderIcon()}
        </div>
      </div>
    </div>
  );
};

StatCard.propTypes = {
  number: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  title: PropTypes.string.isRequired,
  icon: PropTypes.oneOfType([
    PropTypes.object, // FontAwesome icon object
    PropTypes.string  // KeenIcon icon name
  ]),
  iconType: PropTypes.oneOf(['fontawesome', 'keenicon']),
  className: PropTypes.string,
};

export { StatCard };
